import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
// CSS
import styles from './Routes.module.css';
// Components
import TabbedView from '../Components/Utils/TabbedView/TabbedView';
import { ITab } from '../Types/ITab';
import ImproveActive from './Improve/ImproveActive';
import ImproveArchive from './Improve/ImproveArchive';
import { useAppDispatch, useAppSelector } from '../Redux/Store/Store';
import { getClient } from '../Redux/Store/Slices/client';
import { ImportQuestionnaireTemplate } from '../API/TemplateBank/TemplateBank';
import { setQuestionnaire } from '../Redux/Store/Slices/questionnaire';
import { ImportImproveTemplate } from '../API/Improve/Improve';
import Popup from '../Components/Utils/Popup/Popup';
import ImportTemplate from '../Components/Products/ImportTemplate/ImportTemplate';
import { ProductType } from '../Types/ProductType';

const tabs: ITab[] = [
  {
    title: 'Active',
    active: true,
    url: '/improve/active'
  },
  {
    title: 'Archive',
    active: false,
    url: '/improve/archive'
  }
];

const Improve = () => {

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const location = useLocation();
  const [activeTab, setActiveTab] = useState<ITab>(tabs[0]);
  const [showImportTemplate, setShowImportTemplate] = useState<boolean>(false);

  const client = useAppSelector(getClient);

  useEffect(() => {
    const selectedTab = tabs.find((tab) => location.pathname.startsWith(tab.url));

    if (selectedTab && selectedTab.title !== activeTab.title) {
      setActiveTab(selectedTab);
    }
  }, [location.pathname, activeTab.title]);

  const handleImportTemplate = (templateId: string, observee?: string, departmentId?: string, partnerId?: string, groupIds?: string[]) => {
    const importTemplate = async () => {
      if(client){
        const improvementPlan = await ImportImproveTemplate(templateId, client.id, departmentId, partnerId, groupIds); 
        navigate(`/improve/${improvementPlan.id}`);
      }
    }
    return importTemplate();
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3>Track</h3>
        <TabbedView data={tabs} activeTab={activeTab} activeTabChanged={setActiveTab} />
      </div>
      <div className={styles.body}>
        <Routes>
          <Route index element={<Navigate to="active" replace />} />
          <Route path="active" element={<ImproveActive setShowImportTemplate={setShowImportTemplate}/>} />
          <Route path="archive" element={<ImproveArchive setShowImportTemplate={setShowImportTemplate} />} />
        </Routes>
      </div>

      <Popup  isVisible={showImportTemplate} onClose={() => setShowImportTemplate(!showImportTemplate)}>
          <ImportTemplate importHandler={handleImportTemplate} productType={ProductType.Improve} />
      </Popup>
    </div>
  );
};

export default Improve;